"use client";

import { useEffect, useRef } from "react";

import { Button } from "@/components/ui/button";

export type HeroStickyQuizJumpControlsProps = {
  visible: boolean;
  quizSectionId?: string;
  label?: string;
};

export function HeroStickyQuizJumpControls({
  visible,
  quizSectionId = "find-your-path-experience",
  label = "Start quiz",
}: HeroStickyQuizJumpControlsProps) {
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const el = buttonRef.current;
    if (!visible && el && document.activeElement === el) {
      el.blur();
    }
  }, [visible]);

  const handleJump = () => {
    document.getElementById(quizSectionId)?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <div
      className={`md:hidden fixed bottom-0 left-0 right-0 z-[60] px-4 pb-[max(env(safe-area-inset-bottom),12px)] pt-3 bg-white/95 border-t border-putty-300 backdrop-blur-sm transition-[transform] duration-200 motion-reduce:transition-none ${
        visible ? "translate-y-0" : "translate-y-full pointer-events-none"
      }`}
      aria-hidden={!visible}
      data-testid="fyp-mobile-sticky-quiz-bar"
    >
      <Button
        ref={buttonRef}
        variant="brand"
        radius="md"
        className="w-full"
        type="button"
        tabIndex={visible ? undefined : -1}
        onClick={handleJump}
      >
        {label}
      </Button>
    </div>
  );
}
